"use client"

import { useState, useEffect } from "react"
import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
} from "@clerk/nextjs"
import { cn } from "@/lib/utils"
import { createColorThemeVars } from "@/lib/color-generation/utils/colorUtils"
import "@/app/mastermind/farbvelo-effects.css"

// Import the AsciiArtService
import { AsciiArtService } from "@/lib/ascii-art";

export default function Home() {
  const [currentPalette, setCurrentPalette] = useState<string[]>([])
  const [showBackground, setShowBackground] = useState(true)
  const [showGlow, setShowGlow] = useState(true)
  const [colorBleed, setColorBleed] = useState(true)

  // Load palette from sessionStorage on mount
  useEffect(() => {
    const loadPalette = () => {
      try {
        const storedPalette = sessionStorage.getItem('mastermind-palette');
        if (storedPalette) {
          const paletteData = JSON.parse(storedPalette);
          setCurrentPalette(paletteData.palette || []);
          setShowBackground(paletteData.showBackground !== false);
          setShowGlow(paletteData.showGlow !== false);
          setColorBleed(paletteData.colorBleed !== false);
        }
      } catch (error) {
        console.warn('[landing-page]: Failed to load palette:', error);
      }
    };

    loadPalette();

    // Listen for palette updates from other pages
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'mastermind-palette') {
        loadPalette();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Generate CSS custom properties for gradients
  const gradientVars = currentPalette.length > 0 ? createColorThemeVars(currentPalette) : {};

  return (
    <div 
      className={cn(
        "flex h-[calc(100vh-3.5rem)] flex-col items-center justify-center gap-6",
        showBackground && "mastermind-has-background",
        showGlow && "mastermind-message-glow",
        colorBleed && "mastermind-message-bleed"
      )}
      style={gradientVars}
    >
      <SignedIn>
        <pre className="font-mono text-sm mb-4">{AsciiArtService.getNirvana()}</pre>
        <h1 className="text-4xl font-bold text-center">Welcome to the MasterMind Alliance</h1>
        <p className="text-lg text-muted-foreground text-center">
          Use the navigation bar to pick a workspace.
        </p>
      </SignedIn>

      <SignedOut>
        <div className="text-center space-y-4">
          <pre className="font-mono text-sm mb-4">{AsciiArtService.getNirvana()}</pre>
          <h1 className="text-4xl font-bold">MasterMind</h1>
          <p className="text-lg text-muted-foreground">
            Sign in to access the app.
          </p>
          <div className="flex flex-row gap-4 justify-center mt-6">
            <SignInButton mode="redirect">
              <button className="bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-2 rounded">
                Sign In
              </button>
            </SignInButton>
            <SignUpButton mode="redirect">
              <button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 px-4 py-2 rounded">
                Sign Up
              </button>
            </SignUpButton>
          </div>
        </div>
      </SignedOut>
    </div>
  )
}